<template>
    <Breadcrumbs main="Users" title="User Profile" />
    <div class="container-fluid">
        <div class="user-profile">
            <div class="row">
                <profileHeader />
                <profilePost />
                <profilePost1 />
                <profilePost2 />
                <profilePost3 />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const profileHeader = defineAsyncComponent(() => import("@/components/theme/user/profile/profileHeader.vue"))
const profilePost = defineAsyncComponent(() => import("@/components/theme/user/profile/profilePost.vue"))
const profilePost1 = defineAsyncComponent(() => import("@/components/theme/user/profile/profilePost1.vue"))
const profilePost2 = defineAsyncComponent(() => import("@/components/theme/user/profile/profilePost2.vue"))
const profilePost3 = defineAsyncComponent(() => import("@/components/theme/user/profile/profilePost3.vue"))
</script>